import * as wishlistActions from 'aster-foundation/core/epharmacy/wishlist/redux/actions';
import { REDIRECT_URI } from 'aster-foundation/core/common/utils/ApiConst';
import { useRouter } from 'next/router';
import Image from 'next/image';
import PropTypes from 'prop-types';
import React, { useRef, useState, useEffect } from 'react';
import ReactImageMagnify from 'react-image-magnify';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { checkIfCurrentRegionIsSaudi, getImageUrlWithSize } from '@common/Utility/common-utils';
import { IC_BOOKMARK, IC_BOOKMARK_CHECKED_GREEN, IC_SHARE, PRODUCT_CARD_DEFAULT, IC_VIDEO_PDP } from '@common/Assets/images';
import useWindowDimensions from '@common/Context/useWindowDimensions';
import { CART_TYPES, WISHLIST_GA_EVENT, WISHLIST_TYPES, AE_GLOBAL, FLAGSMITH_KEYS } from '@common/Utility/constants';
import { EventEmitter } from '@common/Utility/eventEmitter';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { dataLayerSendEvent, wishlistAddRemoveGAEvent } from 'Epharmacy/EpharmacyAnalytics';
import ShareProduct from '../ShareProduct';
import CategoryItem from './CategoryItem';
import ProductBadges from './ProductBadges';
import CustomModal from '@common/Component/Modal/Modal';
import SlickSlider from '@common/Component/SlickSlider/SlickSlider';
import { sendLoginEvent } from '@common/Utility/analytics-utils';
import { useAuth } from '@common/AuthService';
import { errorHandlingEpharmacy, getIsInstoreApp, getReferralPageForGA } from '@common/Utility/common-utils';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { flagsmith } from '@common/Lib/Flagsmith';
import { isRTL, useTranslation } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../../i18n';

const ProductShowCase = ({ detailsData, customAttribute, showVideo, setShowVideo, selectedMediaID, setSelectedMediaId, isPOMEnabled }) => {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const ref = useRef();
  const { authCtx } = useAuth();
  const dispatch = useDispatch();
  const windowWidth = useWindowDimensions();
  const zoneData = useSelector((state) => state?.app?.userLocationReducer?.zone);
  const userZoneData = useSelector((state) => state?.epharmacy?.updateUserZone?.data?.additionalInfo);
  const [isSecondSlide, setIsSecondSlide] = React.useState(false);
  const [selectedImage, setSelectedImage] = React?.useState(customAttribute?.image);
  const [selectedMedia, setSelectedMedia] = useState('');
  const [videoTitle, setVideoTitle] = useState('');
  const [showLoginModal, setShowLoginModal] = React.useState(false);
  const [active, setActive] = React.useState('1');
  const [isClickOnShare, setClickOnShare] = React.useState(false);
  const [showMobileSlider, setShowMobileSlider] = React.useState(false);
  const [keyHighlights, setKeyHighlights] = React.useState([]);
  const [currentLang, setCurrentLanguage] = React.useState('');
  const pageType = getReferralPageForGA(router?.asPath);
  const screenName = router?.pathname;
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);
  const myShoppingList = useSelector((state) => state?.app?.myShoppingListReducer);
  const wishListSkuIds = (myShoppingList?.wishList || [])?.map(listItem => listItem?.sku);
  const [isInWishList, setIsInWishList] = React.useState(
    wishListSkuIds?.find((sku) => sku === detailsData?.sku) || false,
  );
  const sliderWrapper = useRef();
  const t = useTranslation();

  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});

  React.useEffect(() => {
    if(typeof window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);

  React.useEffect(() => {
    if (wishListSkuIds) {
      setIsInWishList(wishListSkuIds?.find((sku) => sku === detailsData?.sku));
    }
  }, [wishListSkuIds, detailsData?.sku]);

  const shareClickEvent = () => {
    dataLayerSendEvent('click_share', {});
  };

  React.useEffect(() => {
    setSelectedImage(customAttribute?.image ?? '');
    setActive('1');
  }, [customAttribute]);

  React.useEffect(() => {
    if (detailsData?.extensionAttributes?.highlights) {
      const highlightsData = detailsData?.extensionAttributes?.highlights?.slice(0, 4);
      setKeyHighlights(highlightsData);
    }
  }, [detailsData]);

  React.useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isClickOnShare && ref.current && !ref.current.contains(e.target)) {
        setClickOnShare(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isClickOnShare]);

  const LoginCheck = () => {
    if (!authCtx?.authenticated) {
      setShowLoginModal(true);
      return false;
    } else {
      return true;
    }
  };

  const redirectToLogin = () => {
    sendLoginEvent(router.asPath);
    authCtx.login({ redirectUri: REDIRECT_URI + generateURL(`?asPath=${encodeURIComponent(router.asPath)}`) });
  };

  const addIntoWishlist = () => {
    if (LoginCheck()) {
      const params = {
        sku: [detailsData?.sku],
        userId: userLogin?.id,
        cart_type: CART_TYPES.AE,
        wishlist_type: WISHLIST_TYPES.AE,
        wishlist_name: "Shopping List 1", //TODO: for now we are keeping it as hard coded will change later, discussed with shivendra 
        is_default: true
      };

      if (userZoneData) {
        params.zones = userZoneData;
      }

      dispatch(
        wishlistActions?.addToWishList({
          params: params,
          onSuccess: (response) => {
            wishlistAddRemoveGAEvent(WISHLIST_GA_EVENT.ADD_TO_WISHLIST, detailsData, {
              item_list_name: 'Product Details Page',
            });
            const properties = {
              type: 'Product Details Page',
            };
            sendEventToSmartLook('add_to_wishlist', properties);
            setIsInWishList(true);
            EventEmitter.dispatch('fetchWishList', {zone: userZoneData, userLogin});
            if (response.status === 200) {
              EventEmitter.dispatch('setToastControlMessage', { message: response?.body?.message ? response?.body?.message : '' });
            } else {
              toast.error(response?.body ? response?.body : '');
            }
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, screenName, pageType);
            toast.error(err?.data ? err?.data : '');
          },
        }),
      );
    }
  };

  const removeFromWishlist = (moveToCart = false) => {
    if (LoginCheck()) {
      const params = {
        sku: [detailsData?.sku],
        add_to_cart: moveToCart,
        zones : userZoneData,
        cart_type: CART_TYPES.AE,
        wishlist_type: WISHLIST_TYPES.AE,
        userId: userLogin?.id
      }
      dispatch(
        wishlistActions?.removeFromWishList({
          params: params,
          onSuccess: (response) => {
            setIsInWishList(false);
            EventEmitter.dispatch('fetchWishList', { zone: userZoneData, userLogin });
            wishlistAddRemoveGAEvent(WISHLIST_GA_EVENT.REMOVE_FROM_WISHLIST, detailsData, {
              item_list_name: 'Product Details Page',
            });
            sendEventToSmartLook('remove_from_wishlist', 'remove_from_wishlist');
            if (response.status === 200) {
              EventEmitter.dispatch('setToastControlMessage', { message: response?.body?.message ? response?.body?.message : '' });
            } else {
              toast.error(response?.body ? response?.body : '');
            }
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, screenName, pageType);
            toast.error(err?.data ? err?.data : '');
          },
        }),
      );
    }
  };

  const getShareProductEvent = () => {
    dataLayerSendEvent('share_product_details', {
      screen_name: detailsData?.name,
      page_type: 'product details page',
      myaster_category: 'epharmacy',
      product_name: detailsData?.name,
      product_sku: detailsData?.sku,
      price: parseFloat(detailsData?.specialPrice) || parseFloat(detailsData?.price),
      currency: 'AED',
    });
    sendEventToSmartLook('share_product_details');
  };
  
  useEffect(() => {
    if (isClickOnShare) {
      getShareProductEvent();
    }
  }, [isClickOnShare]); 
  
  const windowWidthValue = React.useMemo(() => {
    return windowWidth?.width;
  }, [windowWidth?.width]);
  React.useEffect(() => {
    if (windowWidthValue < 540) {
      setShowMobileSlider(true);
    } else {
      setShowMobileSlider(false);
    }
  }, [windowWidthValue]);

  const showMediaSlider = () => {
    if (detailsData?.mediaGalleryEntries?.length >= 1) {
      return (
        <div className="productSliderMobileWrapper" ref={sliderWrapper}>
          <SlickSlider
            sliderSettings={{
              slidesToShow: 1,
              infinite: true,
              className: '',
              dots: true,
              vertical: false,
              arrows: false,
              beforeChange: (oldIndex, newIndex) => {
                if (newIndex === 1) setIsSecondSlide(true);
                else {
                  setIsSecondSlide(false);
                }
              },
            }}
          >
            {detailsData?.mediaGalleryEntries?.[0] && keyHighlights?.length > 0 && (
              <>
                <CategoryItem
                  key="0"
                  categoryImage={detailsData?.mediaGalleryEntries?.[0]?.file}
                  categoryName={detailsData?.mediaGalleryEntries?.[0]?.label}
                  setActive={setActive}
                  detailsData={detailsData}
                  setSelectedImage={setSelectedImage}
                  setSelectedMedia={setSelectedMedia}
                  setSelectedMediaId={setSelectedMediaId}
                  setVideoTitle={setVideoTitle}
                  setShowVideo={setShowVideo}
                  showMobileSlider={showMobileSlider}
                />
              </>
            )}
            {detailsData?.mediaGalleryEntries?.map((item, slideIndex) => {
              return (
                <>
                  {windowWidth?.width < 480 && isSecondSlide === true && keyHighlights?.length > 0 && (
                    <div
                      className={`extraInfoForMobile ${slideIndex !== 0 ? 'noMobile' : ''}`}
                      style={{
                        width: sliderWrapper?.current?.offsetWidth ?? 390,
                        height: sliderWrapper?.current?.offsetHeight ?? 335,
                      }}
                    >
                      <div className="infoInside">
                        <div className="keyTitle">{t('ProductDetail.keyhighlights')}</div>
                        {keyHighlights?.length > 0 &&
                          keyHighlights?.slice(0, 4)?.map((item) => {
                            return (
                              <div className="extraInfoRow" key={item?.attributeCode}>
                                <div className="extraInfoLabel">{item?.attributeLabel}</div>
                                <div className="extraInfoValue">{item?.label}</div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  )}
                  <CategoryItem
                    key={item?.id}
                    categoryImage={item?.file}
                    categoryName={item?.label}
                    active={active}
                    setActive={setActive}
                    detailsData={detailsData}
                    setSelectedImage={setSelectedImage}
                    setSelectedMedia={setSelectedMedia}
                    setSelectedMediaId={setSelectedMediaId}
                    setVideoTitle={setVideoTitle}
                    setShowVideo={setShowVideo}
                    item={item}
                    showMobileSlider={showMobileSlider}
                  />
                </>
              );
            })}
          </SlickSlider>
        </div>
      );
    } else {
      return (
        <CategoryItem
          key={detailsData?.mediaGalleryEntries?.[0]?.id}
          categoryImage={detailsData?.mediaGalleryEntries?.[0]?.file}
          categoryName={detailsData?.mediaGalleryEntries?.[0]?.label}
          position={detailsData?.mediaGalleryEntries?.[0]?.position}
          active={active}
          setActive={setActive}
          detailsData={detailsData}
          setSelectedImage={setSelectedImage}
          setSelectedMedia={setSelectedMedia}
          setSelectedMediaId={setSelectedMediaId}
          setVideoTitle={setVideoTitle}
          setShowVideo={setShowVideo}
          showMobileSlider={showMobileSlider}
        />
      );
    }
  };

  const handleVideoPlayer = () => {
    setShowVideo(true);
  };

  return (
    <>
      <div className="productShowCase">
        <div className="productShowcaseWrapper ">
          {showMobileSlider ? (
            showMediaSlider()
          ) : (
            <div className="productShowcase">
              {selectedMedia === 'external-video' ? (
                <div className='videoWrapper' onClick={handleVideoPlayer}>
                  <Image
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = PRODUCT_CARD_DEFAULT?.src;
                    }}
                    src={getImageUrlWithSize(selectedImage, 420, 420)}
                    width={420}
                    height={420}
                    className='img-video-1'
                    unoptimized
                  />
                  <Image src={IC_VIDEO_PDP}
                    width={64}
                    height={64}
                    className='img-video'
                  />
                </div>
              ) : (
                <ReactImageMagnify
                  {...{
                    smallImage: {
                      onError: (currentTarget) => {
                        currentTarget?.target?.setAttribute('src', PRODUCT_CARD_DEFAULT?.src);
                        currentTarget.onerror = null;
                      },
                      alt: detailsData?.name,
                      isFluidWidth: true,
                      src: getImageUrlWithSize(selectedImage, 420, 420) ?? '',
                    },
                    // enlargedImageContainerDimensions:{width:"150%", height:"150%"},
                    largeImage: {
                      onError: (currentTarget) => {
                        currentTarget?.target?.setAttribute('src', PRODUCT_CARD_DEFAULT?.src);
                        currentTarget.onerror = null;
                      },
                      src: getImageUrlWithSize(selectedImage,700,600) ?? '',
                      width: 700,
                      height: 600,
                    },
                    ...(currentLang && isRTL(currentLang) && {
                      enlargedImageContainerStyle: {
                        left: '0%',
                        right: '100%',
                        zIndex: 1,
                        direction: 'ltr',
                      }
                    })                
                  }}
                />
              )}
            </div>
          )}

          <ProductBadges badgeDetails={detailsData?.badgeDetails} isSecondSlide={isSecondSlide} isPOMEnabled={isPOMEnabled} hasRX={detailsData?.itemLabels?.includes(AE_GLOBAL?.RX)} />

          <div className={isSecondSlide === true ? 'noMobile' : ''}>
            {!getIsInstoreApp() && web_feature_flaging?.isWishlistEnable ? (
              <div className="addToWishList" onClick={() => (isInWishList ? removeFromWishlist() : addIntoWishlist())}>
                <Image
                  src={isInWishList ? IC_BOOKMARK_CHECKED_GREEN.src : IC_BOOKMARK.src}
                  alt=""
                  width={14}
                  height={18}
                />
              </div>
            ) : null}
            {!getIsInstoreApp() && (
              <div className="share-tost" ref={ref} style={!web_feature_flaging?.isWishlistEnable ? {top: "20px"} : {}}>
                <div className="filter">
                  <div className="ic">
                    <Image
                      data-test="shareIcon"
                      src={IC_SHARE.src}
                      width="18px"
                      height="20px"
                      alt={detailsData?.name}
                      onClick={() => {
                        setClickOnShare(!isClickOnShare);
                        shareClickEvent();
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  {isClickOnShare && (
                    <ShareProduct
                      productName={detailsData?.name}
                      shareBy={''}
                      productType={'Non-Rx'}
                      productSku={detailsData?.sku}
                      brand={detailsData?.brandDetails?.brandName}
                      productCategory={
                        detailsData?.categoryPath ? detailsData?.categoryPath : customAttribute?.categoryIds
                      }
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="productCarousalWrapper noMobile">
          {detailsData?.mediaGalleryEntries?.length > 1 ? (
            <SlickSlider
              sliderSettings={{
                slidesToShow:
                  detailsData?.mediaGalleryEntries?.length >= 5 ? 5 : detailsData?.mediaGalleryEntries?.length,
                infinite: true,

                className: '',
                dots: false,
                vertical: false,
                variableWidth: true,
                arrows: true,
              }}
            >
              {detailsData?.mediaGalleryEntries?.map((item) => {
                return (
                  <CategoryItem
                    key={item?.id}
                    categoryImage={item?.file}
                    categoryName={item?.label}
                    position={item?.position}
                    active={active}
                    setActive={setActive}
                    detailsData={detailsData}
                    item={item}
                    setSelectedImage={setSelectedImage}
                    setSelectedMedia={setSelectedMedia}
                    setSelectedMediaId={setSelectedMediaId}
                    setVideoTitle={setVideoTitle}
                    setShowVideo={setShowVideo}
                    showMobileSlider={showMobileSlider}
                  />
                );
              })}
            </SlickSlider>
          ) : (
            <CategoryItem
              key={detailsData?.mediaGalleryEntries?.[0]?.id}
              categoryImage={detailsData?.mediaGalleryEntries?.[0]?.file}
              categoryName={detailsData?.mediaGalleryEntries?.[0]?.label}
              position={detailsData?.mediaGalleryEntries?.[0]?.position}
              active={active}
              setActive={setActive}
              detailsData={detailsData}
              setSelectedImage={setSelectedImage}
              setSelectedMedia={setSelectedMedia}
              setSelectedMediaId={setSelectedMediaId}
              setVideoTitle={setVideoTitle}
              setShowVideo={setShowVideo}
              showMobileSlider={showMobileSlider}
            />
          )}
        </div>
      </div>
      {showLoginModal && (
        <CustomModal
          bodyTextCenter
          footerBtnFullWidth={true}
          modalTitle={t('loginRegister')}
          size="md"
          footerAlignment="center"
          primaryButtonText={t('loginRegister')}
          secondaryButtonText="Cancel"
          primaryButtonClicked={() => redirectToLogin()}
          seconderyButtonClcked={() => setShowLoginModal(false)}
        >
          <p className="mb-0 font-17">{t('EPharmacyHome.pleaseLoginRegisterFirstToProceed')}</p>
        </CustomModal>
      )}

      {showVideo && (
        <CustomModal
          bodyTextCenter
          modalTitle=" "
          size="lg"
          footerAlignment="center"
          closeButton
          crossPressed={() => setShowVideo(false)}
          noFooter
          customClass='video-player'
        >
          <iframe className='video'
            title='Youtube player'
            src={`https://youtube.com/embed/${selectedMediaID}?loop=1&autoplay=1&rel=0&playlist=${selectedMediaID}`}
            allow='autoplay'
            allowFullScreen
            sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation"
            width={'100%'}
            height={450}
            >
          </iframe>
        </CustomModal>
      )}
    </>
  );
};

ProductShowCase.propTypes = {
  detailsData: PropTypes.object,
  customAttribute: PropTypes.any,
  isPOMEnabled: PropTypes.bool,
};
ProductShowCase.propTypes = {
  isPOMEnabled: false,
  customAttribute: '',
  detailsData: {},
};
export default ProductShowCase;
